const awsmobile = {
  Auth: {
    region: "us-east-1",
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_CLIENT_ID
  }
};

export default awsmobile;
